import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "land-plot-modal-bottom" }
const _hoisted_2 = { class: "land-plot-modal-bottom__slider" }
const _hoisted_3 = {
  key: 1,
  class: "land-plot-modal-bottom__slider-placeholder"
}
const _hoisted_4 = { class: "land-plot-modal-bottom__info" }
const _hoisted_5 = { class: "land-plot-modal-bottom__info-title" }
const _hoisted_6 = { class: "land-plot-modal-bottom__info-subtitle" }

import { computed } from 'vue';
    import CustomList from '@/components/commons/CustomList.vue';
    import SliderGallery from '@/components/slider/SliderGallery.vue';
    import { CustomListItem } from '@/types/common/CustomList';
    import { ILandPlot } from '@/types/LandPLot';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LandPlotModalBottom',
  props: {
    landPlot: {}
  },
  setup(__props: any) {

    const props = __props;

    const listBottom = computed<Array<CustomListItem>>(() => {
        if (props.landPlot.house)
            return props.landPlot.house.in.map(i => ({
                id: i.id,
                title: i.name,
                text: i.value,
            }));
        return [];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.landPlot.house?.images.length)
        ? (_openBlock(), _createBlock(SliderGallery, {
            key: 0,
            images: _ctx.landPlot.house.images,
            mode: "house"
          }, null, 8, ["images"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.landPlot.house?.name), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.landPlot.house ? _ctx.landPlot.house.descriptionIn : ''), 1),
      (listBottom.value.length)
        ? (_openBlock(), _createBlock(CustomList, {
            key: 0,
            class: "land-plot-modal-bottom__info-list",
            list: listBottom.value,
            theme: "even"
          }, null, 8, ["list"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})